import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ArticleMatcherPermissions } from '@mp/content-manager/article-matching/article-matcher/feature';
import { ArticleRangesPermissions } from '@mp/content-manager/article-ranges/feature';
import { ArticleSearchPermissions } from '@mp/content-manager/article-search/feature';
import { provideCategoriesExport } from '@mp/content-manager/categories/data-access';
import { CategoriesPermissions, createExcelExportCategoriesPlugin } from '@mp/content-manager/categories/feature';
import {
  ClinicCatalogsPermissions,
  createClinicCatalogInfoTabPlugin,
} from '@mp/content-manager/clinic-catalogs/feature';
import { IndustryCatalogsPermissions } from '@mp/content-manager/industry-catalogs/feature';
import { PlatformCatalogsPermissions } from '@mp/content-manager/platform-catalogs/feature';
import { SupplyDisruptionsPermissions } from '@mp/content-manager/supply-disruptions/feature';
import { SubstitutePermissions } from '@mp/content-manager/substitutes/feature';
import { UploadPermissions } from '@mp/content-manager/upload/feature';
import { provideModuleInfo } from '@mp/shared/util';
import { provideModulePermissions } from '@mpk/shared/data-access';
import { CURRENT_ORGANIZATION_INFO_TAB_PLUGIN } from '@mpk/shared/util';

const moduleName = 'ContentManager';

export function provideContentManagerFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'Content Management',
    }),
    provideModulePermissions(
      moduleName,
      ArticleMatcherPermissions,
      ArticleSearchPermissions,
      IndustryCatalogsPermissions,
      ClinicCatalogsPermissions,
      PlatformCatalogsPermissions,
      ArticleRangesPermissions,
      SupplyDisruptionsPermissions,
      UploadPermissions,
      CategoriesPermissions,
      SubstitutePermissions,
    ),
    provideCategoriesExport(createExcelExportCategoriesPlugin),
    makeEnvironmentProviders([
      {
        provide: CURRENT_ORGANIZATION_INFO_TAB_PLUGIN,
        multi: true,
        useFactory: createClinicCatalogInfoTabPlugin,
      },
    ]),
  ];
}
